const { DateTime } = require('../states/QuestionType');

var Primary = require('Decorators').Primary;

var PictureMetaDataItem = function () {
    this.GalleryKey     = String;
    this.SearchKey      = String;
    this.PictureId      = Primary(Number);
    this.ThumbNailUrl   = String;
    this.PictureUrl     = String;
    this.Selected       = Number;
    this.Latitude       = Number;
    this.Longitude      = Number;
    this.ImageSource    = String;
    this.TimeStamp      = Date;
    this.MetaData       = Object;
    this.FileNameFields = Object;
    this.DisplayFields  = Object;
}

module.exports = PictureMetaDataItem;